<template>
    <v-col>
        <p class="green--text font-weight-bold mb-3 text-h6">
            {{ title }}
        </p>
        <p class="primary--text font-weight-bold mb-1">
            {{ text }}
        </p>
    </v-col>
</template>
<script>
export default {
    props : {
        title: {
            type: String
        },
        text: {
            type: String
        }
    }
}
</script>
<style lang="sass"></style>